module.exports = __webpack_public_path__ + "static/img/ProximaNova-Regular.13f36682.svg";